"use strict";
// Theme orchestrator – mirrors the structure of qem-web-app/app/themes/createTheme.ts.
// Each concern lives in its own file; this file only assembles the final theme object.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemeByKey = exports.boxShadowsToDropShadows = void 0;
const styles_1 = require("@mui/material/styles");
const themeUtils_1 = require("themes/themeUtils");
const re_reselect_1 = require("re-reselect");
const createPalette_1 = __importDefault(require("themes/createPalette"));
const createTypography_1 = __importDefault(require("themes/createTypography"));
const createComponents_1 = __importDefault(require("themes/createComponents"));
const createMixins_1 = __importDefault(require("themes/createMixins"));
// ---- Utility (re-exported for external consumers) ----
const boxShadowsToDropShadows = (boxShadows) => {
    var _a;
    const boxShadowsMatches = (_a = boxShadows.matchAll) === null || _a === void 0 ? void 0 : _a.call(boxShadows, /(.+?(?:\([^)]*\))*?)(?:,|$)/g);
    const dropShadows = boxShadowsMatches && Array.from(boxShadowsMatches, (match) => match.length ? match[1] : undefined)
        .filter((boxShadow) => !!(boxShadow === null || boxShadow === void 0 ? void 0 : boxShadow.includes(' ')))
        .map((boxShadow) => {
        const boxShadowParamsMatches = boxShadow.matchAll(/(\S+?(?:\(.*?\))?)(?:\s|$)+/g);
        const boxShadowParams = Array.from(boxShadowParamsMatches, (match) => match.length ? match[1] : undefined);
        return `drop-shadow(${boxShadowParams
            .filter((param) => param !== 'inset')
            .filter((param, index) => index !== 3 || !/^(\+|-)?\d+?.*?$/m.test(param !== null && param !== void 0 ? param : ''))
            .join(' ')})`;
    })
        .join(' ');
    return dropShadows || boxShadows;
};
exports.boxShadowsToDropShadows = boxShadowsToDropShadows;
// ---- Shape helpers ----
const steps = 20;
const singleStep = 100 / steps;
const halfStep = singleStep / 2;
const bottomCutOffPath = [...Array(steps + 1).keys()]
    .slice(1, steps + 1)
    .reverse()
    .map((step) => `${step * singleStep}% ${100}%, ${step * singleStep - halfStep}% ${100 - halfStep}%, ${step * singleStep - halfStep - halfStep}% ${100}%`)
    .join(', ');
const bottomCutOffClipPath = `polygon(0 0, 100% 0, 100% 100%, ${bottomCutOffPath}, 0 100%)`;
const createThemeOverrides = (mode) => {
    const paletteOptions = (0, createPalette_1.default)(mode);
    // Both palette files fully define all fields — safe to treat as resolved Palette
    // for internal factory functions that need required (non-optional) color access.
    const palette = paletteOptions;
    return {
        palette: paletteOptions,
        typography: (0, createTypography_1.default)(palette),
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 768,
                lg: 960,
                xl: 1280,
                xxl: 1920,
            },
        },
        spacing: 8,
        mixins: (0, createMixins_1.default)(palette),
        shape: {
            padding: [0, 4, 8, 12, 16, 20, 24, 32, 40, 48, 56, 64, 70, 78, 86, 94, 102],
            shapesRadius: {
                rounded: '50%',
            },
            bottomCutOffClipPath,
        },
        defaults: {
            dense: window.screen.width > 1024,
            content: {
                height: '100%',
                width: 960,
                pageMinWidth: 690,
                paddingLeft: 32,
                paddingLeftMobile: 32,
                paddingRight: 32,
                paddingRightMobile: 32,
            },
            headers: {
                subHeaderHeight: 54,
                subHeaderHeightTall: 70,
                headerHeight: 70,
            },
        },
        components: (0, createComponents_1.default)(palette),
        applyOpacityToHex: themeUtils_1.applyOpacityToHex,
        replaceRgbaColor: themeUtils_1.replaceRgbaColor,
        project: 'Quicken',
    };
};
// ---- Selector ----
// don't use this method directly ever
exports.getThemeByKey = (0, re_reselect_1.createCachedSelector)((themeKey) => themeKey || 'light', (themeKey) => {
    const themeOverrides = createThemeOverrides(themeKey);
    return (0, styles_1.createTheme)(themeOverrides);
})({
    keySelector: (themeKey) => themeKey || '',
    cacheObject: new re_reselect_1.LruObjectCache({ cacheSize: 5 }),
});
